import { InjectionToken, Optional, Provider, SkipSelf } from '@angular/core';

export const iconToken = new InjectionToken<Record<string, string>[]>('Icons Token');

export function provideIcons(icons: Record<string, string>): Provider[] {
  return [
    {
      provide: iconToken,
      // TODO: sanity check for undefined icons here. Make a map of all available icons and compare, reduce array etc
      useFactory: () => icons,
      // deps: [new SkipSelf()],
      deps: [[iconToken, new Optional(), new SkipSelf()]],
      multi: true
    }
  ];
}
